import { createSelector } from '@reduxjs/toolkit';
import { projectsDataSelector, projectsHasErroredSelector, projectsIsLoadingSelector, projectsDiscoveryPanelsSelector } from './projects.selector';
import { loggedInUserSelector } from './loggedInUser.selector';
import { filesHasErroredSelector, filesIsLoadingSelector, filesDataSelector, filesSelectedFilesIsLoadingSelector, filesIsPublishingSelector, filesIsRemovingSelector } from './files.selector';
import { idleStatusSelector } from './idle.selector';
import { searchResultsSelector, searchResultsIsLoadingSelector, searchResultsHasErroredSelector } from './searchResults.selector';
import { sampleSetDataDataSelector, sampleSetDataIsLoadingSelector, sampleSetDataHasErroredSelector } from './sampleSetData.selector';
import { managedProjectsSelector, managedProjectsHasErrored, managedProjectsIsLoading } from './managedProjects.selector';
import { availableRolesSelector } from './availableRoles.selector';
import { publishSummaryDataSelector, publishSummaryHasErroredSelector, publishSummaryIsLoadingSelector } from './publishSummary.selector';
import files from '@/data/files';


export const callbackComponentSelector = createSelector(
    projectsDataSelector,
    projectsHasErroredSelector,
    projectsIsLoadingSelector,
    loggedInUserSelector,
    (projects, hasErrored, isLoading, loggedInUser) => ({ projects, hasErrored, isLoading, loggedInUser })
);


export const projectCardComponentSelector = createSelector(
    filesHasErroredSelector,
    filesIsLoadingSelector,
    filesDataSelector,
    (hasErrored, isLoading, files) => ({ hasErrored, isLoading, files })
);


export const idleTimerComponentSelector = createSelector(
    idleStatusSelector,
    (idleStatus) => ({ idleStatus })
);


export const filesTableComponentSelector = createSelector(
    filesHasErroredSelector,
    filesIsLoadingSelector,
    filesSelectedFilesIsLoadingSelector,
    (hasErrored, isLoading, isSelectedLoading) => ({ hasErrored, isLoading, isSelectedLoading })
);


export const searchContainerComponentSelector = createSelector(
    searchResultsHasErroredSelector,
    searchResultsIsLoadingSelector,
    searchResultsSelector,
    (hasErrored, isLoading, searchResults) => ({ hasErrored, isLoading, searchResults })
);


export const publishingCenterComponentSelector = createSelector(
    projectsHasErroredSelector,
    projectsIsLoadingSelector,
    sampleSetDataDataSelector,
    sampleSetDataHasErroredSelector,
    sampleSetDataIsLoadingSelector,
    loggedInUserSelector,
    (hasErrored, isLoading, sampleSets, sampleSetsHasErrored, sampleSetsIsLoading, loggedInUser) => ({ hasErrored, isLoading, sampleSets, sampleSetsHasErrored, sampleSetsIsLoading, loggedInUser })
);


export const publishingProjectFilesComponentSelector = createSelector(
    filesHasErroredSelector,
    filesIsLoadingSelector,
    filesSelectedFilesIsLoadingSelector,
    filesDataSelector,
    (hasErrored, isLoading, isSelectedLoading, files) => ({ hasErrored, isLoading, isSelectedLoading, files })
);


export const adminSamplesetsComponentSelector = createSelector(
    sampleSetDataHasErroredSelector,
    sampleSetDataIsLoadingSelector,
    sampleSetDataDataSelector,
    (hasErrored, isLoading, adminSampleSetData) => ({ hasErrored, isLoading, adminSampleSetData })
);




export const mainLayoutComponentSelector = createSelector(
    projectsDataSelector,
    projectsDiscoveryPanelsSelector,
    projectsHasErroredSelector,
    projectsIsLoadingSelector,
    (projects, discoveryPanels, hasErrored, isLoading) => ({ projects, discoveryPanels, hasErrored, isLoading })
);


export const projectContainerComponentSelector = createSelector(
    projectsDataSelector,
    projectsHasErroredSelector,
    projectsIsLoadingSelector,
    sampleSetDataDataSelector,
    sampleSetDataHasErroredSelector,
    sampleSetDataIsLoadingSelector,
    publishSummaryDataSelector,
    publishSummaryHasErroredSelector,
    publishSummaryIsLoadingSelector,
    loggedInUserSelector,
    (projects, hasErrored, isLoading, sampleSets, sampleSetHasErrored, sampleSetIsLoading, publishSummary, publishSummaryHasErrored, publishSummaryIsLoading, loggedInUser) => ({
        projects,
        hasErrored,
        isLoading,
        sampleSets,
        sampleSetHasErrored,
        sampleSetIsLoading,
        publishSummary,
        publishSummaryHasErrored,
        publishSummaryIsLoading,
        loggedInUser
    })
);


export const projectFilesComponentSelector = createSelector(
    filesHasErroredSelector,
    filesIsLoadingSelector,
    filesSelectedFilesIsLoadingSelector,
    filesDataSelector,
		filesIsPublishingSelector,
		filesIsRemovingSelector,
    (hasErrored, isLoading, isSelectedLoading, files, isPublishing, isRemoving) => ({ hasErrored, isLoading, isSelectedLoading, files, isPublishing, isRemoving })  
);


export const projectResultsComponentSelector = createSelector(
    filesHasErroredSelector,
    filesIsLoadingSelector,
    filesDataSelector,
    (hasErrored, isLoading, files) => ({ hasErrored, isLoading, files })
);


export const securityCheckComponentSelector = createSelector(
    loggedInUserSelector,
    (loggedInUser) => ({ loggedInUser })
);


export const routeAuthorizationComponentSelector = createSelector(
    loggedInUserSelector,
    (loggedInUser) => ({ loggedInUser })
);
